import { Button } from "@/components/ui/button";
import Text from "@/components/ui/text";
import React from "react";
import { useNavigate } from "react-router-dom";

interface Props {
  labels: { message: string; button: string };
}

const ConnectEmailBanner: React.FC<Props> = ({ labels }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-surface-sidebar-navigation pr-2 pl-2">
      <div
        className="h-9 flex w-full bg-surface-connect-email-banner items-center justify-center gap-2 px-2 py-0 transition-all duration-300 rounded-b-lg"
        data-test="connect-email-banner"
      >
        <Text className="text-center break-words text-on-surface">
          {labels.message}
        </Text>
        <Button
          variant="tertiary"
          onClick={() => navigate("/settings/connectedAccounts")}
          data-test="connect-email-banner-button"
        >
          {labels.button}
        </Button>
      </div>
    </div>
  );
};

export default ConnectEmailBanner;
